import { formatCouponDiscount } from '@/helpers/coupon';
import type { TransactionCouponUsed } from '@/types/transaction';
import { Chip, Tooltip } from '@mui/material';
import { memo, useState } from 'react';

type Props = {
  value?: TransactionCouponUsed | null;
};

/**
 * Dashed chip showing just the coupon code; the discount (e.g. "15% Off Fees") reveals on
 * hover or click/tap rather than being spelled out inline in the table.
 */
const TransactionsSaleCoupon = ({ value }: Props) => {
  const [open, setOpen] = useState(false);

  if (!value?.code) {
    return null;
  }

  const discount = formatCouponDiscount(value);

  return (
    <Tooltip
      title={discount || 'No discount details'}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      <Chip
        variant="outlined"
        size="small"
        label={value.code}
        onClick={() => setOpen((prev) => !prev)}
        sx={(theme) => ({
          border: `1px dashed ${theme.palette.grey['500']}`,
          cursor: 'pointer',
        })}
      />
    </Tooltip>
  );
};

export default memo(TransactionsSaleCoupon);
